import { StatRecord, StorageStatRecord } from "@dashboard-v3/api";
import reduce90Days from "../reduce90Days";

type Totals = ReturnType<typeof emptyResults>;
type UploadedType = Exclude<keyof Totals, "all">;
export type FilesSumData = Array<{ date: number } & Totals>;

export function parseData(data: Array<StatRecord>): FilesSumData {
  return reduce90Days<Totals>(data, "storage", emptyResults, (totals, stat) => {
    const records = stat as StorageStatRecord[];

    records.forEach(record => {
      Object.keys(record).forEach(key => {
        const uploadedType = getUploadedType(key);

        if (uploadedType) {
          totals[uploadedType] += record[key];
          totals.all += record[key];
        }
      });
    });

    return totals;
  });
}

function emptyResults() {
  return {
    all: 0,
    attachments: 0,
    bodies: 0,
    emails: 0,
    zip: 0,
  };
}

function getUploadedType(key: string): UploadedType {
  if (key.includes("FilesEMAIL")) return "emails";
  if (key.includes("FilesPDF")) return "bodies";
  if (key.includes("FilesATTACHMENT")) return "attachments";
  if (key.includes("FilesZIP")) return "zip";

  return null;
}
